var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('label',{attrs:{"for":"message"}},[_vm._v(_vm._s(_vm.title))]),_c('vue-autosuggest',{attrs:{"suggestions":_vm.filteredOptions,"limit":10,"input-props":{
          id: 'autosuggest__input',
          class: 'form-control',
          placeholder: 'Search by username, email, firstname, lastname',
        },"render-suggestion":_vm.renderSuggestion},on:{"input":_vm.onInputChange,"selected":_vm.selectHandler},model:{value:(_vm.currentUser),callback:function ($$v) {_vm.currentUser=$$v},expression:"currentUser"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }